import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../../App.css';
import Dashheader from '../Dash-header/Dashheader';
import Sidebar from '../dashboard/Sidebar';
import '../faqs/faqWrapp.css';
import FaqItem from '../faqs/FaqItem';
import Rolling from '../../images/rollng.gif';
import { END_URL } from '../../config';
import UserFooter from '../footer/UserFooter.jsx';

function FaqWrapp() {
  const [faqsByCategory, setFaqsByCategory] = useState({});
  const [Loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dynamicContent, setDynamicContent] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [expanded1, setExpanded] = useState(false);
  const [openFaqId, setOpenFaqId] = useState(null);

  // Refs for smooth scrolling
  const faqRefs = useRef({});

  useEffect(() => {
    async function fetchFaqs() {
      try {
        setLoading(false);
        setError(null);

        const response = await axios.get(`${END_URL}faq`);
        const result = response.data;

        if (result.status && result.data) {
          const grouped = result.data.reduce((acc, faq) => {
            const categoryName = faq.faqcategory?.name || 'Uncategorized';
            if (!acc[categoryName]) acc[categoryName] = [];
            acc[categoryName].push(faq);
            return acc;
          }, {});
          setFaqsByCategory(grouped);

          const firstCategory = Object.keys(grouped)[0];
  if (firstCategory && grouped[firstCategory].length > 0) {
    setOpenFaqId(grouped[firstCategory][0].id);
  }



        } else {
          setError('Failed to fetch FAQs');
        }
      } catch (err) {
        setError(err.message || 'Something went wrong');
      } finally {
        setLoading(true);
      }
    }
    fetchFaqs();
  }, []);

  useEffect(() => {
    const fetchDynamicContent = async () => {
      try {
        const response = await axios.get(`${END_URL}dynamic-page`);
        setDynamicContent(response.data.data);
      } catch (error) {
        console.error('Failed to fetch dynamic content:', error);
      }
    };
    fetchDynamicContent();
  }, []);

  // Filter & Search
  const displayedFaqsByCategory = Object.entries(faqsByCategory).reduce((acc, [category, faqs]) => {
    if (selectedCategory === "All" || category === selectedCategory) {
      const filteredFaqs = faqs.filter(faq =>
        faq.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        faq.content.toLowerCase().includes(searchTerm.toLowerCase())
      );
      if (filteredFaqs.length > 0) acc[category] = filteredFaqs;
    }
    return acc;
  }, {});

  const allCategoryOptions = ["All", ...Object.keys(faqsByCategory)];

  const topQuestions = Object.values(faqsByCategory)
    .flat()
    .filter(faq => faq.topquestions === 1);

  // Scroll to open FAQ when changed
  // useEffect(() => {
  //   if (openFaqId && faqRefs.current[openFaqId]) {
  //     faqRefs.current[openFaqId].scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   }
  // }, [openFaqId]);

    useEffect(() => {
      if (openFaqId && faqRefs.current[openFaqId]) {
 
        setTimeout(() => {
          faqRefs.current[openFaqId].scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest' 
          });
        }, 300);
      }
    }, [openFaqId]);


  return (
    <div className="dashboard-container full-width">
      <Dashheader />
      <div className="container">
        <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
          <div className="col-md-3">
            <div className="dashboard-side-div">
              <Sidebar />
              <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
            </div>
          </div>

          <div className="col-md-9">
            <main className="content">
              <div className="dashbord-first">
                <div dangerouslySetInnerHTML={{ __html: dynamicContent?.faq1 }} />
              </div>

              <div className="faq-wrapp">
                <div className="main-col">
                  {/* Search/filter controls */}
                  <div className="faq-filter-controls mb-4" style={{ display: 'flex', gap: '16px' }}>
                    <input
                      type="text"
                      placeholder="Search FAQs..."
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                      className="faq-search-box form-control"
                    />
                    <select
                      value={selectedCategory}
                      onChange={e => setSelectedCategory(e.target.value)}
                      className="faq-category-dropdown form-select"
                    >
                      {allCategoryOptions.map(cat => (
                        <option key={cat} value={cat}>{cat}</option>
                      ))}
                    </select>
                  </div>

                  {Loading ? (
                    <div className="faq-row row">
                      {displayedFaqsByCategory && Object.keys(displayedFaqsByCategory).length > 0 ? (
                        Object.entries(displayedFaqsByCategory).map(([category, faqs]) => (
                          <div key={category} className="faq-col11">
                         
                            <div className="row">
                              {faqs.map(faq => (
                                <div
                                  key={faq.id}
                                  ref={el => (faqRefs.current[faq.id] = el)}
                                  className="col-12"
                                >
                                  <div className="faq-col1">
                                    <FaqItem
                                      question={faq?.title}
                                      answer={<span dangerouslySetInnerHTML={{ __html: faq?.content }} />}
                                      isOpen={openFaqId === faq.id}
                                      onToggle={() =>
                                        setOpenFaqId(openFaqId === faq.id ? null : faq.id)
                                      }
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="no-faq">
                          <h3>No Questions Found</h3>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className='Loading-case' style={{width:"100%", background:"#fff", border:"1px solid #e7eceb", boxShadow:"0 10px 28px rgb(0 0 0 / .05)", borderRadius:"12px", textAlign:"center", padding:"40px 0"}}>
                      <img style={{maxWidth:"100px",margin:"0 auto 0"}} src={Rolling} alt="loading" />
                    </div>
                  )}
                </div>

                {/* Right Side Column */}
                <div className="side-col">
                  <div className="contn-card">
                    <h3>Top Questions</h3>
                    <div className="cont-list">
                      {topQuestions.length > 0 ? (
                        topQuestions.map(faq => (
                          <a
                            key={faq.id}
                            className="link"
                            onClick={e => {
                              e.preventDefault();
                              // setSelectedCategory(faq.faqcategory?.name || "All");
                              setSearchTerm('');
                              setOpenFaqId(faq.id);
                            }}
                          >
                            {faq.title}
                          </a>
                        ))
                      ) : (
                        <p>No top questions available.</p>
                      )}
                    </div>
                  </div>





                 <div className="contn-card">
  <h3>{dynamicContent?.faqsideheading}</h3>
  <div className="cont-list">
    <p dangerouslySetInnerHTML={{ __html: dynamicContent?.faqsidedescription }} />
    <a href="/contact" className="faq-btn">Contact Us</a>
  </div>
</div>

                </div>
              </div>
              <UserFooter />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqWrapp;
